import { render, staticRenderFns } from "./TeamChampPerformance.vue?vue&type=template&id=02912a6a&"
import script from "./TeamChampPerformance.vue?vue&type=script&lang=ts&"
export * from "./TeamChampPerformance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
